$(document).ready(function () {

  var isProduct = $("body").hasClass("template-product");

  // Policy page title
  if (window.location.href === "https://sifts.co/policies/refund-policy") {
    $(".shopify-policy__title h1").text("Returns & Refund Policy");
  }

  var btn = $(".cust-btn");
  var oneTime = $(".one-time-txt");

  // Variant selection
  $(document).on("click", ".variant-option", function () {
    var el = $(this);

    $(".variant-option").removeClass("checked-variant");
    el.addClass("checked-variant");

    var varId = el.find(".variant-detail-top").attr("varidsel");
    var group = el.find(".variant-detail-top").attr("atcgroup");
    var price = el.find(".variant-detail-top").attr("actprice");

    if (varId) {
      btn.attr("var_id", varId);
      oneTime.attr("var_id2", varId);
    }

    if (group) {
      $("input.atc_group").val(group);
    }

    if (price) {
      $(".one-time-txt span").text(price);
    }
  });

  // Auto select first variant (important)
  if (!isProduct) {
    $(".variant-option:first").trigger("click");
  }

  // Product page URL variant handling
  function updateVariantFromURL() {
    if (!isProduct) return;

    var params = new URLSearchParams(window.location.search);
    var variant = params.get("variant");

    if (variant) {
      btn.attr("var_id", variant);
      oneTime.attr("var_id2", variant);
      updateATCGroup();
      updatePrice();
    }
  }

  function updateATCGroup() {
    var selected = $(".variant-option.checked-variant");

    if (selected.length > 0) {
      var group = selected.find(".variant-detail-top").attr("atcgroup");

      if (group) {
        $("input.atc_group").val(group);
      }
    }
  }

  function updatePrice() {
    var selected = $(".variant-option.checked-variant");

    if (selected.length > 0) {
      var price = selected.find(".variant-detail-top").attr("actprice");

      if (price) {
        $(".one-time-txt span").text(price);
      }
    }
  }

  updateVariantFromURL();
  updateATCGroup();
  updatePrice();

  $(document).on("variant:change", function () {
    updateATCGroup();
    updatePrice();
  });

  // URL change watcher
  var currentUrl = location.href;

  setInterval(function () {
    if (location.href !== currentUrl) {
      currentUrl = location.href;
      updateVariantFromURL();
    }
  }, 500);

  // ✅ FIXED: One-time purchase
  oneTime.on("click", function (e) {
    e.preventDefault();

    var variantId = $(this).attr("var_id2");
    var group;

    var selected = $(".variant-option.checked-variant");

    console.log("Selected variant:", selected);

    if (selected.length > 0) {
      group = selected.find(".variant-detail-top").attr("atcgroup");
    }

    if (variantId && group) {
      var cartDrawer = document.querySelector('cart-drawer');

      // Include sections in the add request — Shopify returns rendered HTML atomically
      var sectionsNeeded = cartDrawer
        ? cartDrawer.getSectionsToRender().map(function(s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(group), quantity: 1 }],
          sections: sectionsNeeded,
          sections_url: window.location.pathname
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.status) {
          alert("There was an error adding the product to the cart.");
          return;
        }
        if (!cartDrawer) {
          window.location.href = '/cart';
          return;
        }
        if (response.sections && typeof cartDrawer.renderContents === 'function') {
          // Remove is-empty before renderContents so open() targets the right container
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
        } else {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.open();
        }
      })
      .catch(function() {
        window.location.href = '/cart';
      });
    } else {
      alert("Variant ID or ATC Group is missing!");
    }
  });

  // Subscription purchase
  btn.on("click", function (e) {
    e.preventDefault();

    var variantId = btn.attr("var_id");
    var group = $("input.atc_group").val();
    var plan = null;

    if (variantId == 47306439983256) plan = 4087611544;
    if (variantId == 47306440016024) plan = 4087644312;
    if (variantId == 47306440048792) plan = 4087677080;

    if (variantId && group && plan) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: [{ id: group, quantity: 1, selling_plan: plan }]
        },
        dataType: "json",
        success: function () {
          window.location.href = "/checkout";
        },
        error: function () {
          alert("There was an error adding the subscription.");
        }
      });
    } else {
      alert("Variant ID, ATC Group, or Selling Plan is missing!");
    }
  });

  // Slick sliders
  function initTestimonials() {
    if ($(window).width() < 768) {
      if (!$(".testimonials-list").hasClass("slick-initialized")) {
        $(".testimonials-list").slick({
          slidesToShow: 1,
          dots: true,
          arrows: false
        });
      }
    } else {
      if ($(".testimonials-list").hasClass("slick-initialized")) {
        $(".testimonials-list").slick("unslick");
      }
    }
  }

  function initMobileSlider() {
    if ($(window).width() <= 767) {
      if (!$(".mob-o-slider").hasClass("slick-initialized")) {
        $(".mob-o-slider").slick({
          slidesToShow: 3,
          arrows: true
        });
      }
    } else {
      if ($(".mob-o-slider").hasClass("slick-initialized")) {
        $(".mob-o-slider").slick("unslick");
      }
    }
  }

  function initSec4Carousels() {
    var $deskList = $('.new-figma-sec4 .desk-mode .ingredient-list');
    var $mobList  = $('.new-figma-sec4 .mobile-mode .ingredient-list');

    if ($deskList.length && !$deskList.hasClass('slick-initialized')) {
      $deskList.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        responsive: [{ breakpoint: 1024, settings: { slidesToShow: 2 } }]
      });
    }

    if ($mobList.length && !$mobList.hasClass('slick-initialized')) {
      $mobList.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false
      });
    }
  }

  initTestimonials();
  initMobileSlider();
  initSec4Carousels();

  $(window).on("resize", function () {
    initTestimonials();
    initMobileSlider();
  });

  // Sticky CTA
  var sticky = document.querySelector(".sticky-atc-try-m");
  var header = document.querySelector(".section-header");
  var section = document.querySelector(".try-page-product-sec");

  window.addEventListener("scroll", function () {
    if (!header || !section) return;

    if (header.getBoundingClientRect().bottom < 0) {
      sticky.classList.add("active");
    } else {
      sticky.classList.remove("active");
    }

    var rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      sticky.classList.remove("active");
    }
  });

});